import { connect } from "react-redux";

import MoveButton from "./MoveButton";
import MovePanel from "./MovePanel";

const mapStateToProps = ({ map }) => ({
    disabled: map.general.selectedLights.length <= 0,
});

export default {
    button: connect(mapStateToProps, {})(MoveButton),
    name: "move",
    panel: MovePanel,
};
